import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

// Global routes
export const globalIntegrationsRoute: InvariantRoute = {
	name: 'eoc-integrations',
	path: '/jira/settings/products/ops/integrations',
	exact: true,
};
